var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCapacitorinline = function SvgCapacitorinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#capacitor_inline_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#53B9FF",
    d: "M2.491 3.382.02 5.857l3.813 3.824L0 13.524 2.464 16l3.84-3.844 3.818 3.816 2.472-2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#119EFF",
    d: "m8.782 9.68-2.478 2.476 3.818 3.816 2.472-2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m8.782 9.68-2.478 2.476.954.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#53B9FF",
    d: "M12.16 6.312 16 2.467 13.527 0 9.689 3.836 5.869.02 3.399 2.495 13.5 12.61l2.472-2.475z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#119EFF",
    d: "m7.21 6.312 2.479-2.475L5.869.02 3.399 2.495z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.2,
    d: "m7.21 6.312 2.479-2.475-.955-.95z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "capacitor_inline_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCapacitorinline;